<template>
  <div class="virtual dark">
    <div class="loaded">
      <MainHeader
        :dark="true"
        :tiles="!isMobile"
        @tilesClick="tilesClick"
        @logoClick="logoClick">
        <svg>
          <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
          <use v-else xlink:href="#logoWmkSvg"></use>
        </svg>
      </MainHeader>
      <div class="page-container main-container">
        <VirtualMenu v-if="pageNavOpen" :dark="true"/>
        <div class="counter text-m" v-if="!pageNavOpen">
          <div :class="{
                  'arrow': true,
                  'up': true,
                  'hidden': !isPrev
                }"
              :title="buttonData.scrollUp"
              @click="showPrev"></div>
          {{ (activeItem + 1) }}
          <span>
            {{ categories.length }}
          </span>
          <div :class="{
                'arrow': true,
                'down': true,
                'hidden': !isNext
              }"
              :title="buttonData.scrollDown"
              @click="showNext"></div>
        </div>
        <div class="page-content" v-if="!pageNavOpen">
          <section>
            <header class="section-header">
              <template v-for="(category, index) in categories">
                <div
                  :key="'category-' + index"
                  class="item"
                  :class="{
                    prev: index == activeItem - 1,
                    active: index == activeItem,
                    next: index == activeItem + 1
                  }"
                  v-if="virtualData.categories[category.slug]">
                  <router-link :to="{
                    name: 'search',
                    query: { kategoria: category.slug }
                  }">
                    <h2 class="text-xl"
                        v-accent="virtualData.categories[category.slug].header">
                    </h2>
                    <p class="text-m"
                       v-accent="virtualData.categories[category.slug].description">
                    </p>
                  </router-link>
                </div>
              </template>
            </header>
            <div class="animation item" v-for="(category, index) in categories" :key="index" :class="{
              prev: index == activeItem - 1,
              active: index == activeItem,
              next: index == activeItem + 1,
              [category.name]: true,
              withShadow: true
            }">
              <router-link :to="{
                name: 'search',
                query: { kategoria: category.slug }
              }">
                <img v-if="isMobile" :src="category.imageRest" :alt="category.name">
                <img v-else :src="(!loadedImages.includes(category.image) ? category.imageStatic : category.image)" :alt="category.name">
              </router-link>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import VirtualMenu from '@/components/VirtualMenu.vue'

export default {
  name: 'virtual',
  components: {
    MainHeader,
    VirtualMenu
  },
  data () {
    return {
      activeItem: 0,
      showTimeout: null,
      xDown: null,
      yDown: null,
      loadedImages: []
    }
  },
  methods: {
    ...mapActions([
      'goToNextCategory',
      'goToPrevCategory',
      'togglePageNav',
      'toggleMainNav',
      'setGifsLoaded',
      'resetActiveFilters'
    ]),
    hamburgerClick () {
      this.toggleMainNav()
    },
    tilesClick () {
      this.togglePageNav()
    },
    showNext () {
      this.activeItem = Math.min(this.activeItem + 1, this.categories.length - 1)
    },
    showPrev () {
      this.activeItem = Math.max(this.activeItem - 1, 0)
    },
    handleKeyup (event) {
      switch (event.code) {
        case 'ArrowUp':
        case 'ArrowLeft':
          this.showPrev()
          break
        case 'ArrowDown':
        case 'ArrowRight':
        case 'Space':
          this.showNext()
          break
        default:
      }
    },
    handleWheel (event) {
      clearTimeout(this.showTimeout)
      this.showTimeout = setTimeout(() => {
        if (event.wheelDelta) {
          if (event.wheelDelta > 0) {
            this.showPrev()
          } else {
            this.showNext()
          }
        } else if (event.deltaY) {
          if (event.deltaY < 0) {
            this.showPrev()
          } else {
            this.showNext()
          }
        }
      }, 300)
    },
    handleTouchStart (evt) {
      this.xDown = evt.touches[0].clientX
      this.yDown = evt.touches[0].clientY
    },
    handleTouchMove (evt) {
      if (!this.xDown || !this.yDown) {
        return
      }
      let xUp = evt.touches[0].clientX
      let yUp = evt.touches[0].clientY
      let xDiff = this.xDown - xUp
      let yDiff = this.yDown - yUp

      if (Math.abs(xDiff) > Math.abs(yDiff)) { /* most significant */
        if (xDiff > 0) {
          /* left swipe */
        } else {
          /* right swipe */
        }
      } else {
        if (yDiff > 0) {
          /* up swipe */
          this.showNext()
        } else {
          /* down swipe */
          this.showPrev()
        }
      }
      /* reset values */
      this.xDown = null
      this.yDown = null
    },
    fixedBody () {
      const $body = document.body || document.documentElement
      $body.setAttribute('data-fixed', $body.getAttribute('data-fixed') === 'fixed' ? 'none' : 'fixed')
    },
    logoClick () {
      this.activeItem = Math.max(this.activeItem - 1, 0)
      if (this.activeItem > 0) {
        setTimeout(() => {
          this.logoClick()
        }, 300)
      }
    },
    loadImages () {
      let images = this.categories.map(cat => cat.image)
      images.forEach(imgUrl => {
        if (this.gifsLoaded) {
          let img = new Image()
          img.onload = () => {
            this.loadedImages.push(imgUrl)
          }
          img.src = imgUrl
        } else {
          this.loadedImages.push(imgUrl)
        }
      })
      this.setGifsLoaded()
    }
  },
  created () {
    window.addEventListener('keyup', this.handleKeyup)
    window.addEventListener('wheel', this.handleWheel)
    document.addEventListener('touchstart', this.handleTouchStart, false)
    document.addEventListener('touchmove', this.handleTouchMove, false)

    this.fixedBody()
    this.loadImages()
  },
  destroyed () {
    window.removeEventListener('keyup', this.handleKeyup)
    window.removeEventListener('wheel', this.handleWheel)
    document.removeEventListener('touchstart', this.handleTouchStart)
    document.removeEventListener('touchmove', this.handleTouchMove)

    this.fixedBody()
  },
  mounted () {
    this.loadImages()
    this.resetActiveFilters()
  },
  computed: {
    ...mapGetters([
      'categories',
      'pageNavOpen',
      'activeCategory',
      'breakpoint',
      'virtualData',
      'buttonData',
      'gifsLoaded',
      'selectedTranslation'
    ]),
    isNext () {
      return this.activeItem !== this.categories.length - 1
    },
    isPrev () {
      return this.activeItem !== 0
    },
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  }
}
</script>

<style scoped lang="scss">
.virtual {
  height: 100vh;
  overflow: hidden;
  position: static;
  h2, h3, h4, h5, p {
    letter-spacing: 0.05em;
  }
  .page-container {
    padding: 0;
  }
  .withShadow{
    background-image: url(../assets/images/bg/shadow.png);
  }
  /deep/ {
    .main-header {
      @include mobile {
        .header-options {
          bottom: $gap-sm;
          position: fixed;
          // top: 94vh;

          .custom-select {
            &.open {
              .options {
                bottom: 100%;
                top: auto;

                .hight-contrast & {
                  border-top: 3px solid $contrast-accent;
                  border-bottom: 0 none;
                } // END .hight-contrast .main-header .header-options .custom-select.open;
              } // END .options;
            } // END .custom-select.open;
          } // END .custom-select;
        } // END .header-options;
      } // END @include mobile;
    } // END .main-header;
  }
}
.dark {
  background-color: $bg-dark;
  color: $text-light;
}
.main-container {
  @include mobile {
    top: 12vw;
    left: 6vw;
    position: fixed;
  }
}
.page-content {
  position: relative;
  height: 100vh;
  z-index: 1;
  .animation {
    &:focus {
      outline: none;
    }
    a {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.counter {
  line-height: 2em;
  position: absolute;
  top: 46vh;
  top: calc(50% - 40px);
  right: 50px;
  font-weight: bold;
  z-index: 99999;
  text-align: center;
  min-width: 1.5em;

  span {
    display: block;
    border-top: 1px solid $text-light;
    padding: 3px 0;
    margin: 5px 0;
  }
  @include mobile {
    top: auto;
    bottom: 0;
    right: 50px;
    position: fixed;
  }
}
.arrow {
  width: 20px;
  height: 24px;
  margin: -12px 0 0 0;
  position: absolute;
  top: 50%;
  cursor: pointer;
  background: transparent url(../assets/images/icons/scroll_down_white.svg) no-repeat center;
  background-size: contain;
  animation-name: heartbeatmove;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  &.up {
    animation-delay: 1s;
    background-image: url(../assets/images/icons/scroll_up_white.svg);
    left: -30px;
  }
  &.down {
    right: -30px;
  }
  &.hidden {
    visibility: hidden;
  }
  // animation-direction: alternate;
}
.item {
  display: none;
  transition: $transitionSlider;

  a {
    color: $text-light;
    text-decoration: none;
  }

  &.prev {
    display: block;
    transform: translateX(-100vw);
    opacity: 0.3;
  }
  &.next {
    display: block;
    transform: translateX(100vw);
    opacity: 0.3;
  }
  &.active {
    display: block;
    transform: translateX(0);
    opacity: 1;
  }
}
.animation {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 60vw;
  width: 60vw;
  height: 50vh;
  transform: translate3d(-50%, -50%, 0);
  z-index: 11;
  transition: all .5s;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  &.prev {
    display: block;
    transform: translate3d(-50%, -200vh, 0);
    opacity: 0.3;
  }
  &.next {
    display: block;
    transform: translate3d(-50%, 200vh, 0);
    opacity: 0.3;
  }
  &.active {
    display: block;
    transform: translate3d(-50%, -50%, 0);
    opacity: 1;
  }
  a {
    display: block;
    position: relative;
    // top: 50%;
    // left: 0;
    width: 100%;
    height: 100%;
    // transform: translateY(-50%);
    text-align: center;
    align-content: center;
  }
  @include tablet {
    a,
    img {
      transition: none;
      text-align: center;
    }
    &.planes {
      img {
        width: 86%;
      }
    }
    &.copier {
      img {
        width: 94%;
      }
    }
    &.typewriters,
    &.radios,
    &.others,
    &.cars {
      img {
        width: 91%;
      }
    }
  }
  @include mobile {
    width: 90%;
    max-width: 100%;
    top: auto;
    bottom: 40px;
    transform: translate(-50%, -50%);
    height: 33vh;
    &.active {
      transform: translate(-50%, -50%);
    }
  }
}
.section-header {
  width: 350px;
  max-height: 70vh;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 25vh;
  left: 0;
  text-align: left;
  z-index: 20;

  @include screen('min-height') {
    top: 17vh;
  }

  h2 {
    text-transform: uppercase;
    position: relative;
    margin: 0 0 25px 0;
    padding: 0 0 21px 0;
    &:before {
      content: '';
      display: block;
      width: 40px;
      height: 3px;
      background-color: $text-light;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  p {
    max-width: 400px;
    text-shadow: 0 3px 5px $bg-dark;
  }
  .item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 20;
  }
  @include mobile {
    top: 31px;
    width: 100%;
    h2 {
      padding: 0 2px 21px 2px;
      &:before {
        left: 2px;
      }
    }
    p {
      max-width: 100%;
      padding: 0 2px;
    }
  }
}
section {
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  a {
    display: block;
  }
  img {
    max-width: 70%;
    transition: $transition;
    @include biger-then-tablet {
      &:hover {
        transform: scale(1.1);
      }
    }
  }
  @include mobile {
    img {
      max-width: 100%;
    }
  }
}
header {
  z-index: 9;
  position: relative;
}
@keyframes heartbeatmove
{
  0%
  {
    transform: translateY(-5px);
  }
  50%
  {
    transform: translateY(5px);
  }
  100%
  {
    transform: translateY(-5px);
  }
}
</style>
